// Articoli "Guide antitruffa" — ogni articolo diventa una pagina indicizzabile
// su /guida/<slug>. Per pubblicarne uno nuovo basta aggiungere un oggetto qui.
export const articles = [
  {
    slug: "truffa-sms-pacco-in-giacenza",
    title: "SMS del pacco in giacenza: come riconoscere la truffa e cosa fare",
    seoTitle: "SMS truffa del pacco in giacenza: come riconoscerla",
    description:
      "«Il tuo pacco è in giacenza, paga per la consegna»: questo SMS è quasi sempre una truffa (smishing). Ecco come riconoscerla, cosa fare e come verificare un link sospetto gratis.",
    date: "2026-07-14",
    category: "SMS truffa",
    readMinutes: 4,
    intro:
      "Ti è arrivato un SMS che dice che un pacco è fermo in giacenza e che devi pagare una piccola somma — di solito 1 o 2 euro — per riceverlo? Fermati: è una delle truffe via SMS più diffuse in Italia. Si chiama smishing, cioè phishing fatto con gli SMS. In questa guida ti spieghiamo, con parole semplici, come riconoscerla e cosa fare.",
    sections: [
      {
        heading: "Come funziona questa truffa",
        paragraphs: [
          "I truffatori mandano migliaia di SMS che sembrano arrivare da un corriere (Poste, BRT, DHL, GLS o altri). Il messaggio dice che c'è un pacco bloccato e ti invita a cliccare su un link per pagare la consegna.",
          "Il link porta a una pagina finta, molto simile a quella vera del corriere, dove ti chiedono i dati della carta di credito. La cifra richiesta è volutamente piccola per non insospettirti: ma una volta inseriti i dati, i truffatori possono usare la tua carta per prelievi molto più grandi, oppure abbonarti a servizi a pagamento nascosti.",
        ],
      },
      {
        heading: "I campanelli d'allarme per riconoscerla",
        warningList: [
          "Non aspetti nessun pacco, oppure il corriere nominato non è quello che usi di solito",
          "Il link nell'SMS è strano: lettere e numeri a caso, oppure non finisce con l'indirizzo ufficiale del corriere",
          "Ti chiedono di pagare una piccola somma (1–3 euro) per «sbloccare» la consegna",
          "Il messaggio mette fretta: «ultimo avviso», «il pacco verrà restituito entro 24 ore»",
          "Ci sono errori di italiano o frasi che suonano strane",
        ],
      },
      {
        heading: "Cosa fare se ricevi questo SMS",
        okList: [
          "Non cliccare sul link e non inserire mai i dati della carta",
          "Se aspetti davvero un pacco, controlla la spedizione solo sull'app o sul sito ufficiale del corriere, usando il codice di tracciamento che ti ha dato il negozio",
          "Cancella l'SMS e blocca il numero",
          "Se non sei sicuro, copia il testo dell'SMS e verificalo gratis con lo strumento di ScudoNonni: ti risponde in pochi secondi",
        ],
      },
      {
        heading: "E se ho già cliccato o inserito i dati della carta?",
        paragraphs: [
          "Niente panico, ma agisci subito: chiama la tua banca (il numero è stampato dietro la carta) e chiedi di bloccare la carta. Controlla poi i movimenti del conto nei giorni successivi.",
          "Segnala l'accaduto alla Polizia Postale: puoi farlo online sul sito del Commissariato di P.S. (www.commissariatodips.it) oppure recandoti in un ufficio di polizia. In caso di emergenza chiama il 112.",
        ],
      },
    ],
    related: ["phishing-email-banca-poste", "truffa-whatsapp-finto-figlio"],
  },
  {
    slug: "truffa-whatsapp-finto-figlio",
    title:
      "«Ciao mamma, ho cambiato numero»: la truffa WhatsApp del finto figlio o nipote",
    seoTitle: "Truffa WhatsApp del finto figlio: «Ciao mamma ho cambiato numero»",
    description:
      "Un messaggio WhatsApp da un numero sconosciuto dice di essere tuo figlio o tuo nipote e chiede soldi con urgenza? È una truffa molto diffusa. Ecco come riconoscerla e difenderti.",
    date: "2026-07-14",
    category: "WhatsApp truffa",
    readMinutes: 4,
    intro:
      "«Ciao mamma, mi è caduto il telefono, questo è il mio nuovo numero». Comincia quasi sempre così una delle truffe WhatsApp più crudeli: i truffatori si fingono un figlio o un nipote in difficoltà e, dopo qualche messaggio affettuoso, chiedono soldi con urgenza. Vediamo come funziona e come proteggersi.",
    sections: [
      {
        heading: "Come funziona la truffa del finto familiare",
        paragraphs: [
          "Ricevi un messaggio da un numero che non conosci. Chi scrive dice di essere tuo figlio, tua figlia o un nipote, e spiega di aver perso o rotto il telefono: per questo scrive da un numero nuovo.",
          "Dopo qualche messaggio gentile arriva la richiesta: c'è un pagamento urgente da fare — una bolletta, una multa, un bonifico che «non può fare dal nuovo telefono» — e ti chiede di anticipare tu i soldi, di solito con un bonifico verso un IBAN sconosciuto o con una ricarica.",
          "Un dettaglio tipico: il truffatore evita sempre di parlare al telefono o di fare una videochiamata, con scuse come «il microfono è rotto» o «sono in riunione».",
        ],
      },
      {
        heading: "I campanelli d'allarme",
        warningList: [
          "Il messaggio arriva da un numero sconosciuto che dice di essere un tuo familiare",
          "C'è una richiesta di soldi urgente, da fare «subito»",
          "La persona non vuole parlare al telefono né farsi vedere in videochiamata",
          "Ti chiede di fare un bonifico verso un IBAN che non conosci, o una ricarica",
          "Fa leva sui sentimenti: «mamma aiutami», «non dirlo a papà»",
        ],
      },
      {
        heading: "Cosa fare per difenderti",
        okList: [
          "Chiama il tuo vero figlio o nipote al numero di sempre: è il modo più rapido per smascherare la truffa",
          "Fai una domanda che solo il vero familiare può sapere (un ricordo di famiglia, un soprannome)",
          "Non mandare mai soldi a un IBAN sconosciuto senza aver parlato a voce con il familiare",
          "Blocca e segnala il numero su WhatsApp (tieni premuto sul contatto → Blocca)",
          "Se hai dubbi, copia i messaggi e verificali gratis con lo strumento di ScudoNonni",
        ],
      },
      {
        heading: "Se hai già mandato dei soldi",
        paragraphs: [
          "Contatta subito la tua banca e chiedi se è possibile richiamare il bonifico: se è molto recente, a volte si può bloccare.",
          "Fai denuncia alla Polizia Postale, anche online su www.commissariatodips.it, portando gli screenshot dei messaggi e la ricevuta del pagamento. Non vergognarti: questa truffa colpisce migliaia di persone, anche molto attente.",
        ],
      },
    ],
    related: ["truffa-sms-pacco-in-giacenza", "phishing-email-banca-poste"],
  },
  {
    slug: "phishing-email-banca-poste",
    title:
      "Email sospetta dalla banca o dalle Poste: come riconoscere il phishing",
    seoTitle: "Phishing: riconoscere email sospette di banca o Poste",
    description:
      "«Il tuo conto è stato bloccato, clicca qui»: le email false di banche e Poste sono la forma più comune di phishing. Ecco come riconoscere una email sospetta e come controllare un link.",
    date: "2026-07-14",
    category: "Email sospetta",
    readMinutes: 5,
    intro:
      "Il phishing è una truffa in cui i criminali si fingono la tua banca, Poste Italiane o un altro ente di fiducia per rubarti password e dati della carta. Arriva di solito per email, ma anche via SMS. Riconoscerlo è più facile di quanto pensi: basta sapere dove guardare.",
    sections: [
      {
        heading: "Che cos'è il phishing, spiegato semplice",
        paragraphs: [
          "Immagina un pescatore che lancia l'amo: il truffatore manda migliaia di email identiche sperando che qualcuno «abbocchi». L'email sembra vera — logo, colori e firma della banca — e contiene quasi sempre un motivo urgente per cliccare su un link: il conto bloccato, un accesso anomalo, un rimborso in attesa.",
          "Il link porta a un sito finto, copiato da quello vero. Se lì inserisci il codice cliente e la password, li stai consegnando direttamente ai truffatori, che li useranno per entrare nel tuo vero conto.",
        ],
      },
      {
        heading: "Come riconoscere una email sospetta",
        warningList: [
          "Ti chiede di cliccare su un link e inserire password, PIN o codici: nessuna banca lo fa mai via email",
          "Usa un tono allarmistico: «conto sospeso», «agisci entro 24 ore», «ultimo avviso»",
          "L'indirizzo del mittente è strano: guarda bene cosa c'è dopo la @ (es. «@poste-sicurezza-avvisi.com» invece di «@poste.it»)",
          "Contiene errori di italiano, accenti sbagliati o frasi tradotte male",
          "Il saluto è generico («Gentile cliente») invece del tuo nome e cognome",
        ],
      },
      {
        heading: "Come controllare un link sospetto senza cliccarlo",
        paragraphs: [
          "Regola d'oro: non serve cliccare per capire se un link è pericoloso. Sul computer, passa il mouse sopra il link senza premere: l'indirizzo vero compare in basso. Sul telefono, tieni premuto il dito sul link per qualche secondo: l'indirizzo completo appare in un riquadro, senza aprirlo.",
          "Guarda la parte finale del nome del sito, subito prima della prima barra «/»: quella è l'unica che conta. Se non è esattamente il sito ufficiale (per esempio poste.it o il sito della tua banca), non fidarti.",
          "In alternativa, copia il testo dell'email o del messaggio e incollalo nello strumento gratuito di ScudoNonni: l'intelligenza artificiale lo analizza e ti dice in italiano semplice se è una truffa.",
        ],
      },
      {
        heading: "Cosa fare se ricevi una email di phishing",
        okList: [
          "Non cliccare sul link e non scaricare gli allegati",
          "Non rispondere: confermeresti che il tuo indirizzo email è attivo",
          "Se il dubbio riguarda il tuo conto, chiama la banca al numero stampato sulla carta o sull'estratto conto",
          "Segnala e cancella l'email",
          "Se hai inserito le credenziali su un sito finto: cambia subito la password, avvisa la banca e segnala alla Polizia Postale su www.commissariatodips.it",
        ],
      },
    ],
    related: ["truffa-sms-pacco-in-giacenza", "truffa-whatsapp-finto-figlio"],
  },
];

export const getArticle = (slug) => articles.find((a) => a.slug === slug);
